import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';

import { logging, logPostInfo } from '../../actions/log';
import { getAuthorDetail, getAuthorShowreel } from '../../actions/wallpaper';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { CONTEXT } from '../../config';
import wpAuthorDefault from '../../static/wp_author_default.png';
import { getQueryString } from '../../utils/utils';
import Blank from './Blank';
import styles from './WallPaperAuthorDetail.module.less';
import classNames from 'classnames';

const selectWpAuthorShowreel = createSelector(
  state => {
    return state.wallpaper && state.wallpaper;
  },
  info => info.wpAuthorShowreel,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function WPAuthorDetail() {
  // export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = useHistory();
  const pageContent = useRef();
  const authorShowreel = useSelector(selectWpAuthorShowreel);
  const logInfoData = useSelector(selectLogInfo);

  const [collectNum, setCollectNum] = useState(null);
  const [authorInfo, setAuthorInfo] = useState({});
  const authorId = getQueryString('authorId');
  const [showNumber, setShowNumber] = useState(8);

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Wallpaper_AuthorWorks`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_AuthorWorks',
        label: '',
        param2: {
          source: 'Wallpaper_AuthorWorks',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Wallpaper_AuthorWorks',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  // useActivate(() => {
  //   pagePvLog();
  // });

  useEffect(() => {
    if (authorInfo.collectCount >= 10000) {
      // 初始化心
      setCollectNum(`${Math.round((authorInfo.collectCount / 10000) * 10) / 10}万`);
    } else {
      setCollectNum(authorInfo.collectCount);
    }
  }, [authorInfo]);

  /**
   * 一进来获取作者信息
   */
  useEffect(() => {
    dispatch(
      getAuthorDetail({
        params: { authorId, refresh: true },
        callback: res => {
          setAuthorInfo(res);
        },
      }),
    );
  }, []);

  // 处理回退没有数据白屏的问题
  useActivate(() => {
    if (authorId !== authorShowreel?.pagenation?.authorId) {
      dispatch(
        getAuthorShowreel({
          ...authorShowreel.pagenation,
          authorId,
          skip: 0,
          refresh: true,
        }),
      );
    }
  }, [authorShowreel]);
  /**
   * 获取作者图片
   */
  useEffect(() => {
    if (
      action !== 'POP' ||
      authorShowreel.list.length === 0 ||
      (authorShowreel &&
        authorShowreel.pagenation &&
        authorShowreel.pagenation.authorId &&
        authorId !== authorShowreel.pagenation.authorId)
    ) {
      dispatch(
        getAuthorShowreel({
          ...authorShowreel.pagenation,
          authorId,
          skip: 0,
          refresh: true,
        }),
      );
    }
  }, []);

  const onMouseEnter = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Author_QrCode',
        label: '',
        param2: {
          source: `Wallpaper_AuthorWorks`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId,
        },
      }),
    );
  }, []);

  const handleShowMoreAuthor = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Author_More',
        label: '',
        param2: {
          source: `Wallpaper_AuthorWorks`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId,
        },
      }),
    );
    history.push(`${CONTEXT}/wpauthorlist`);
  });

  const loadMore = useCallback(() => {
    if (!authorShowreel.load) {
      if (authorShowreel.pagenation.count >= authorShowreel.list.length) {
        dispatch(
          getAuthorShowreel({
            ...authorShowreel.pagenation,
            authorId,
            skip: authorShowreel.list.length,
          }),
        );
      }
    }
  });

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(e => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth < 1330) {
      setShowNumber(8);
    } else if (clientWidth >= 1330 && clientWidth < 1465) {
      setShowNumber(10);
    } else if (clientWidth >= 1465 && clientWidth < 1600) {
      setShowNumber(11);
    } else if (clientWidth >= 1600 && clientWidth < 1870) {
      setShowNumber(13);
    } else if (clientWidth >= 1870) {
      setShowNumber(16);
    }
  }, []);

  const getClassType = useCallback((index = 0, number = 8) => {
    const series = {
      '8': {
        small: [1, 6],
        small_space: [2, 3, 7, 0],
        big: [4],
        big_space: [5],
      },
      '10': {
        small: [1, 7],
        small_space: [2, 3, 4, 8, 9, 0],
        big: [5],
        big_space: [6],
      },
      '11': {
        small: [1, 8],
        small_space: [2, 3, 4, 9, 10, 0],
        big: [5],
        big_space: [6, 7],
      },
      '13': {
        small: [1, 9],
        small_space: [2, 3, 4, 5, 10, 11, 12, 0],
        big: [6],
        big_space: [7, 8],
      },
      '16': {
        small: [1, 11],
        small_space: [2, 3, 4, 5, 6, 12, 13, 14, 15, 0],
        big: [7],
        big_space: [8, 9, 10],
      },
    };
    const pos = (index + 1) % parseInt(number);
    let classType = 'small';
    if (series[number].small.indexOf(pos) > -1) {
      classType = 'small';
    }
    if (series[number].small_space.indexOf(pos) > -1) {
      classType = 'small_space';
    }
    if (series[number].big.indexOf(pos) > -1) {
      classType = 'big';
    }
    if (series[number].big_space.indexOf(pos) > -1) {
      classType = 'big_space';
    }
    return classType;
  }, []);

  return (
    <div className={styles.page} ref={pageContent}>
      <div className={styles.page_container}>
        {authorInfo && authorInfo.authorName && (
          <div className={styles.author}>
            <div className={styles.head}>
              <img
                src={(authorInfo && authorInfo.headPortrait) || wpAuthorDefault}
                alt=""
                className={styles.head}
              />
            </div>
            <div className={styles.desc}>
              <div className={styles.block}>
                <div className={styles.name} title={authorInfo && authorInfo.authorName}>
                  {authorInfo && authorInfo.authorName}
                </div>

                <div className={styles.worksNum}>
                  {(authorInfo && authorInfo.wallpaperCount) || 0}&nbsp;作品
                </div>
                {collectNum && authorInfo && authorInfo.collectCount && (
                  <>
                    <div className={styles.divider} />
                    <div className={styles.worksCollect}>{collectNum}&nbsp;收藏</div>
                  </>
                )}
                {authorInfo && authorInfo.qrCode && (
                  <>
                    <div className={styles.divider} />
                    <div className={styles.worksPick} onMouseEnter={onMouseEnter}>
                      <i className="iconfont icon-qrcode" style={{ fontSize: '13px' }} />
                      &nbsp;关注
                      <div className={styles.qrCode}>
                        <img
                          src={authorInfo && authorInfo.qrCode}
                          alt=""
                          className={styles.qrCodeImg}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className={styles.worksDesc} title={authorInfo && authorInfo.authorDesc}>
                {authorInfo && authorInfo.authorDesc}
              </div>
            </div>
            <div className={styles.authorMore} onClick={handleShowMoreAuthor}>
              更多作者
            </div>
          </div>
        )}
        <div className={classNames(styles.works, styles.container)}>
          {authorId === authorShowreel.pagenation.authorId && (
            <InfiniteScroll
              pageStart={1}
              loadMore={loadMore}
              hasMore={authorShowreel.list.length < authorShowreel.pagenation.count}
              loader={
                <div className="loader" key={0}>
                  ----------加载中----------
                </div>
              }
              initialLoad={false}
              useWindow={false}
              getScrollParent={() => pageContent.current}
            >
              <div className={styles.showreel}>
                {authorShowreel.list.map((item, index) => {
                  return (
                    <WallpaperCard
                      wallpaper={item}
                      key={index}
                      cardInfo={{
                        pageSource: 'authorDetail',
                        pageTage: '',
                        authorId,
                        classType: getClassType(index, showNumber),
                        isCollect: true,
                        isWallpaper: true,
                        isDeleteColl: false,
                        isDeleteUsed: false,
                        isPreview: true,
                      }}
                      logInfo={{ source: 'Wallpaper_AuthorWorks' }}
                    />
                  );
                })}
                {authorShowreel.list.length >= authorShowreel.pagenation.count &&
                  authorShowreel.pagenation.count > 5 && (
                    <div className="loader" style={{ width: '100%', paddingBottom: '20px' }}>
                      ----------到底啦----------
                    </div>
                  )}
              </div>
            </InfiniteScroll>
          )}
          <ScrollTop node={pageContent.current} />
        </div>
      </div>
      {authorShowreel.pagenation.count < 1 && (
        <div className={styles.blank}>
          <Blank load={authorShowreel.load} />
        </div>
      )}
    </div>
  );
}
// });

export default () => {
  const history = useHistory();
  const { refresh } = useAliveController();
  const authorId = getQueryString('authorId');

  useEffect(() => {
    if (history.action === 'PUSH') {
      refresh(`wpauthordetial_${authorId}`);
    }
  }, []);

  return (
    <KeepAlive name={`wpauthordetial_${authorId}`} id={authorId}>
      <WPAuthorDetail />
    </KeepAlive>
  );
};
